// ab726
import throttle from 'lodash/throttle';

$(document).ready(function () {
  const $targetElement = $('.js-filters-by-sticky');
  const $stickyElement = $('.js-left-nav-sticky-element');
  let hasClass = false; // Track if class is already added/removed

  if ($targetElement.length === 0) return;

  // Get the initial position of the target element from the top of the document
  const elementOffsetTop = $targetElement.offset().top;

  // Create a throttled scroll handler using Lodash
  // The function will execute at most once every 100ms
  const handleScroll = throttle(function () {
    const scrollY = window.scrollY;

    // Add fixed class when the top of the element reaches the top of the viewport
    if (scrollY >= elementOffsetTop && !hasClass) {
      $targetElement.addClass('fixed');
      hasClass = true;
    } else if (scrollY < elementOffsetTop && hasClass) {
      $targetElement.removeClass('fixed');
      hasClass = false;
    }
  }, 100);

  // Attach the throttled handler to scroll event
  $(window).on('scroll', handleScroll);

  // Initial check on page load
  if (window.scrollY >= elementOffsetTop) {
    $targetElement.addClass('fixed');
    hasClass = true;
  }

  // Add mouse drag scrolling functionality to the horizontal scroll container
  $('.js-filters-by-sticky').on('filtersReady', function () {
    const $container = $(this).find('.horizontal-scroll');
    let mouseIsDown = false;
    let startMouseX;
    let currentMouseX;
    let startScrollLeft;
    const dragThreshold = 2; // pixels to consider it a drag vs click

    $container.css('cursor', 'grab');

    $container.on('mousedown', (e) => {
      mouseIsDown = true;
      $container.css('cursor', 'grabbing');
      startMouseX = e.pageX;
      currentMouseX = startMouseX;
      startScrollLeft = $container.scrollLeft();
      e.preventDefault();
    });

    // Use document-level mouseup/mousemove so fast drags that leave the
    // container boundary don't leave mouseIsDown stuck as true
    $(document).on('mouseup.horizontalDrag', () => {
      if (!mouseIsDown) return;
      mouseIsDown = false;
      $container.css('cursor', 'grab');

      // Consider it a drag if the container scrolled OR the mouse moved —
      // the latter covers the case where the container is at the scroll boundary
      const scrollDelta = Math.abs($container.scrollLeft() - startScrollLeft);
      const mouseDelta = Math.abs(currentMouseX - startMouseX);
      if (scrollDelta > dragThreshold || mouseDelta > dragThreshold) {
        // Use capture phase so this fires before the button's click handler,
        // preventing the filter from being removed after a drag
        $container[0].addEventListener('click', (e) => {
          e.stopPropagation();
          e.preventDefault();
        }, { capture: true, once: true });
      }
    });

    $(document).on('mousemove.horizontalDrag', (e) => {
      if (!mouseIsDown) return;
      e.preventDefault();

      currentMouseX = e.pageX;
      const walk = (currentMouseX - startMouseX) * 2;
      $container.scrollLeft(startScrollLeft - walk);
    });
  });
});


// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/abtest/plp-left-nav-filter-redesign-ab726.js